import { getArtifactTypes } from '@/lib/filters';

export default function TypesOfArtifactOverview({ types, papers, selected, onToggle, title, hint }) {
  const counts = {};
  papers.forEach((p) => {
    getArtifactTypes(p).forEach((t) => {
      counts[t] = (counts[t] || 0) + 1;
    });
  });

  return (
    <section className="inquiry-overview">
      <div className="inquiry-overview__header">
        <h2 className="inquiry-overview__title">{title}</h2>
        {hint && <p className="inquiry-overview__hint">{hint}</p>}
      </div>
      <div className="inquiry-overview__grid">
        {types.map((type) => {
          const isActive = selected.includes(type.id);
          return (
            <button
              key={type.id}
              type="button"
              className={`inquiry-card ${isActive ? 'inquiry-card--active' : ''}`}
              style={{ '--inquiry-color': type.color }}
              onClick={() => onToggle(type.id)}
              aria-pressed={isActive}
            >
              <span className="inquiry-card__swatch" />
              <span className="inquiry-card__label">{type.label}</span>
              <span className="inquiry-card__count">{counts[type.id] || 0}</span>
              {type.description && <span className="inquiry-card__description">{type.description}</span>}
            </button>
          );
        })}
      </div>
    </section>
  );
}
